import moment from 'moment'

import _ from 'lodash'
import * as charts from './charts'
import * as columns from './columns'

import { dateRanges } from '../../../modules/listings/ListingFilterStore';
import { bindShallow } from '../../../uiMigration/bindAngularWithMobx';
import SelectedLocationsStore from '../../../services/locations/SelectedLocationsStore';
import ProvidersStore from '../../../services/providers/ProvidersStore';
import * as mobx from 'mobx';
import listingFilterStore from "../../../modules/listings/ListingFilterStore";

angular.module('clientDashboardApp').controller("ListingAccuracy",
  function (
    $scope, $q, $state, $location, $timeout, $compile,
    locationService, listingService, percentageFilter, numberAbbreviatorFilter, numberFilter, userService, accountsService, reactContainer
  ) {

    const isListingManagementClient = accountsService
      .retrieveCurrentAccountInfo()
      .then(account => account.services.listingManagement);

    $scope.activeSummary = 'providerSummary';

    // Display spinner while api request in progress
    $scope.loadingResults = true;

    $scope.reportRanges = dateRanges;
    $scope.chartType = 'spline'
    $scope.setChartType = (type) => {
      $scope.chartType = type
      drawListingAccuracyLineGraph()
    }

    $scope.providerDisplayName = id => ProvidersStore.displayNameFor(id);
    $scope.Math = Math;

    $scope.providerColumns = columns.providerColumns;
    $scope.locationColumns = columns.locationColumns;



    $scope.searchConfig = {};
    bindShallow($scope, $scope.searchConfig, listingFilterStore.state, {
      initializeFromMobx: true,
      mobxToAngular: ({ groupId, ...rest }) => rest,
    });
    $scope.$on(
      "$destroy",
      mobx.reaction(
        () => SelectedLocationsStore.legacyGroupIdOrAll,
        (groupId) => ($scope.searchConfig.groupId = groupId),
        {
          fireImmediately: true,
        }
      )
    );


    $scope.$watch("searchConfig", function (newConfig, oldConfig) {
      if (!$scope.searchConfig) {
        return;
      }
      // Get difference between start date and end date
      // Report runs too slowly w/ large number of locations and large date range
      const endDate = $scope.searchConfig.endDate !== undefined ? moment($scope.searchConfig.endDate) : moment()
      $scope.daysInDateRange = endDate.diff(moment($scope.searchConfig.startDate), "days")

      if (_.isEqual(newConfig, oldConfig)) {
        return;
      }

      $location.search(Object.assign({}, $scope.searchConfig, {})) // Update url
      reloadEverything();
      $scope.$broadcast('listingAccuracy:reset')
    }, true)


    const drawListingAccuracyLineGraph = () => {
      // Display a marker if there is only one data point (no line can be made from a single point)
      renderHighchartWhenElementAvailable(
        'listingAccuracyLineGraph',
        charts.listingAccuracy($scope.listingAccuracyHistory, $scope.listingAccuracyHistoryPeriods, $scope.chartType)
      )
    }

    const drawNewListingsCreatedGraph = () => {
      renderHighchartWhenElementAvailable(
        'newListingsCreatedGraph',
        charts.newListingsCreated($scope.newListingsCreated, $scope.listingAccuracyHistoryPeriods)
      )
    }


    function renderHighchartWhenElementAvailable(id, config) {
      // TODO this is leaking resources and is the code is duplicated
      let element = document.getElementById(id);
      if (element && element.clientWidth !== 0) {
        // only render the graph once the container has been drawn into shape
        // (hence waiting element.clientWidth has a non-zero value)
        Highcharts.chart(id, config)
      } else {
        $timeout(() => {
          renderHighchartWhenElementAvailable(id, config)
        }, 50)
      }
    }

    function filterParams() {
      return mobx.toJS(listingFilterStore.state)
    }

    $scope.getLocationSearchParams = () => ({
      groupId: $scope.searchConfig.groupId,
      params: filterParams()
    })


    $scope.exportLocations = () => {
      return listingService.exportListingAccuracyReportByLocation(
        $scope.searchConfig.groupId, filterParams())
    }

    $scope.exportProviders = () => {
      return listingService.exportListingAccuracyReportByProvider(
        $scope.searchConfig.groupId, filterParams()
      )
    }

    const fetchAccuracyReport = () => {
      return listingService
        .listingAccuracyReport($scope.searchConfig.groupId, filterParams())
        .then(resp => resp.data)
    }

    $scope.providerSortCol = $scope.providerColumns[0];
    $scope.providerSortDirection = 1;
    $scope.sortProviderTable = (col, toggle = true) => {
      const direction = $scope.providerSortDirection

      if ($scope.providerSortCol === col) {
        if (toggle) {
          $scope.providerSortDirection = direction * -1;
        }
      } else {
        $scope.providerSortCol = col;
        $scope.providerSortDirection = 1;
      }
      $scope.providerSummaries.sort((a, b) => {
        return col.sort(a[col.key], b[col.key]) * $scope.providerSortDirection
      });
    }


    const validProviders = isListingManagementClient.then(lmc =>
      ProvidersStore.validProvidersData(
        $scope.searchConfig.groupId,
        lmc ? 'LISTING_MANAGEMENT' : 'LISTINGS')
    ).then(xs => {
      $scope.providers = xs;
      return xs
    })

    const reloadEverything = () => {
      $scope.loadingResults = true;

      validProviders.then(xs => fetchAccuracyReport())
        .then( (accuracyReport) => {
          $scope.loadingResults = false;
          $scope.listingAccuracyHistory = accuracyReport.listingAccuracyHistory;
          $scope.listingAccuracyHistoryPeriods = accuracyReport.listingAccuracyHistoryPeriods;
          $scope.locationsMonitored = accuracyReport.locationsMonitored;
          $scope.newListingsCreated = accuracyReport.newListingsCreated;
          $scope.overallAccuracy = accuracyReport.overallAccuracy;
          $scope.overallAccuracyDelta = accuracyReport.overallAccuracyDelta;
          $scope.present = accuracyReport.present;
          $scope.presentDelta = accuracyReport.presentDelta;
          $scope.providerSummaries = accuracyReport.providerSummaries;
          $scope.total = accuracyReport.total;

          $scope.sortProviderTable($scope.providerSortCol, false);

          drawListingAccuracyLineGraph();
          drawNewListingsCreatedGraph();

          $scope.$broadcast('listingAccuracy:reset');
        })
    }
  })
